import styled from 'styled-components';
interface ITab {
  isActive: boolean;
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Container = styled.div`
  width: 100%;
  font-family: Spoqa Han Sans Neo;
  background-color: #ffffff;
  box-sizing: border-box;
  border-radius: 16px;
`;
const TabBox = styled.div`
  width: fit-content;
  display: flex;
  flex-direction: row;
  position: relative;
`;

const Tab = styled.div<ITab>`
  width: ${({ isActive }) => (isActive ? '274px' : '286px')};
  height: 68px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  font-weight: 500;
  color: ${({ isActive }) => (isActive ? '#008AFF' : '#989ba2')};
  border-radius: 12px 12px 0 0;
  border: 1px solid ${({ isActive }) => (isActive ? '#008aff' : '#e5e8ea')};
  border-bottom: none;
  background-color: ${({ isActive }) => (isActive ? '#fff' : '#f7f8fc')};
  z-index: 1;
  box-sizing: border-box;
  cursor: pointer;
`;

const PatternBox = styled.div`
  width: 100%;
  display: flex;
  padding: 24px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid #e1e2e4;
  background: #fff;
`;

const ArrowButton = styled.img<{ $isOpen?: boolean }>`
  width: 24px;
  height: 24px;

  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.3s ease;
`;

const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid #e5e8ea;
`;

const Column = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 24px;
  // border-bottom: 1px solid #e5e8ea;
`;

const Block = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
`;
const BlockLabel = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;

  color: #222;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
  span {
    display: flex;
    align-items: center;
  }
`;

const BlockDescriptionSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

const BlockLabelDescription = styled.div`
  color: #616161;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;
`;

const BlockContent = styled.div`
  flex: 1;
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
const BlockContent02 = styled.div`
  flex: 1;
  // padding-right: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
const DateInput = styled.input`
  width: 100%;
  height: 40px;
  /* background-color: #fff; */
  background-color: #f7f8fc;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  box-sizing: border-box;
  border-radius: 8px;
  /* border: 1px solid #e1e2e4; */
  border: none;
  padding: 0 12px;

  -webkit-appearance: none;
  appearance: none;

  &::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
  }

  &:focus {
    outline: none;
    border-color: rgba(23, 30, 38, 0.3);
  }
`;
const RadioButtonLabel = styled.label`
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  color: #616161;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
`;

const ShowOptionButton = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  padding: 8px 20px;
  border-radius: 8px;
  border: 1px solid #008aff;
  font-size: 14px;
  font-weight: 500;
  color: #008aff;

  img {
    width: 16px;
    height: 16px;
  }
`;

const BottomButtonBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;
const ResetButton = styled.button`
  width: 116px;
  height: 51px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid #e1e2e4;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  color: #616161;
  background-color: #fff;
  cursor: pointer;
`;
const NextButton = styled.button`
  width: 132px;
  height: 51px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: none;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  color: #008aff;
  background-color: #eaf2fe;
  cursor: pointer;
`;

const AnalyzeButton = styled.button`
  width: 132px;
  height: 51px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: none;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  color: #fff;
  background-color: #008aff;
  cursor: pointer;
`;
const SelectedArea = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 16px 24px;
`;
const SelectedBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  gap: 11px;
  flex-wrap: wrap;
`;
const SelectedItem = styled.span`
  display: flex;
  padding: 4px 8px;
  align-items: center;
  gap: 2px;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  color: #222;
  background: #f7f8fc;
  border-radius: 9999px;
`;
const TooltipBox = styled.div`
  position: absolute;
  top: 50px;
  left: 75px;
  width: 296px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #e1e2e4;
  box-shadow:
    0px 6px 12px 0px rgba(0, 0, 0, 0.12),
    0px 4px 8px 0px rgba(0, 0, 0, 0.08),
    0px 0px 4px 0px rgba(0, 0, 0, 0.08);
  z-index: 100;
  font-size: 14px;
  font-weight: 400;
  color: #616161;
`;

const TooltipTitle = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  color: #222;
  cursor: pointer;
`;

const InvestmentAmountBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  font-size: 13px;
  font-weight: 400;
  color: #616161;
  width: 100%;
`;

const InvestmentAmountInput = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
  border-radius: 8px;
  background-color: #f5f7fa;
  color: #616161;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  text-wrap: nowrap;
  gap: 8px;

  input {
    width: 100%;
    border: none;
    background: none;
    color: #616161;
    text-align: right;
  }
`;

const GuideBox = styled.div`
  margin-top: 32px;
  width: 100%;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  background-color: #f7f8fc;
  border-radius: 12px;
`;
const GuideList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const GuideListItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
`;

const Number = styled.span`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #008aff;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
`;

const GuideText = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;

const BlueText = styled.span`
  height: 23px;
  padding: 0 4px;
  background-color: #eaf2fe;
  border-radius: 4px;
  color: #008aff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 700;
`;
const RedText = styled.span`
  height: 23px;
  padding: 0 4px;
  background-color: #ffefef;
  border-radius: 4px;
  color: #f45551;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 700;
`;

const AnalysisTabBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 4px;
  border-radius: 8px;
  background-color: rgba(112, 115, 124, 0.08);
`;

interface AnalysisTabProps {
  isActive: boolean;
}

const AnalysisTab = styled.div<AnalysisTabProps>`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: ${({ isActive }) => (isActive ? '#008aff' : 'rgba(55, 56, 60, 0.28)')};
  background-color: ${({ isActive }) => (isActive ? '#fff' : 'none')};
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid ${({ isActive }) => (isActive ? '#008aff' : 'none')};
  padding: 8px 16px;
  gap: 4px;
  line-height: 20px;
  white-space: nowrap;
`;

const TempBox = styled.div`
  color: #989ba2;
  font-size: 12px;
  border-radius: 4px;
  padding: 2px 4px;
  background-color: rgba(112, 115, 124, 0.08);
`;

const FilterRowContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;
const PlusButton = styled.button`
  padding: 12px;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  background-color: #eaf2fe;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  color: #008aff;
`;
const PatternBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const TitleBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 6px;
  align-items: center;
  color: #222222;
  font-size: 16px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 23.2px;
  word-wrap: break-word;

  span {
    color: rgba(55, 56, 60, 0.61);
    font-size: 13px;
    font-weight: 500;
    line-height: 18.85px;
  }
`;

const InputBox = styled.div<{ $disabled?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  height: 40px;
  border-radius: 8px;
  justify-content: space-between;
  padding: 8px 12px;
  background: #f7f8fc;

  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  color: #616161;
  align-items: center;
  position: relative;

  background: ${({ $disabled }) => ($disabled ? '#FAFAFB' : 'F7F8FC')};
  color: ${({ $disabled }) =>
    $disabled ? 'rgba(55, 56, 60, 0.16)' : 'rgba(55, 56, 60, 0.61)'};

  &:focus-within {
    border: 1px solid #008aff;
  }
`;

const NumberInput = styled.input`
  width: 100%;
  border: none;
  background-color: transparent;
  font-size: 14px;
  font-weight: 500;
  box-sizing: border-box;

  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &:focus {
    outline: none;
  }
  &:disabled::placeholder {
    color: rgba(55, 56, 60, 0.16);
  }
`;

const InputDescription = styled.div`
  padding: 0 12px;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  white-space: nowrap;
  color: #616161;
  position: absolute;
  gap: 10px;
  left: 0;
  bottom: -24px;
`;

const CheckButtonLabel = styled.label`
  display: flex;
  padding: 8px 0;
  width: 100%;
  align-items: center;
  gap: 4px;
  color: #616161;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
  cursor: pointer;
  input {
    display: none;
  }
`;
const RadioButtonLabel02 = styled.label<{
  checked: boolean;
  disabled?: boolean;
}>`
  display: flex;
  font-weight: 500;
  padding: 8px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid
    ${({ checked, disabled }) =>
      disabled ? '#E1E2E4' : checked ? '#008aff' : '#e1e2e4'};
  background: ${({ checked, disabled }) =>
    disabled ? '#F7F7F8' : checked ? '#eaf2fe' : '#fff'};
  color: ${({ checked, disabled }) =>
    disabled ? 'rgba(55, 56, 60, 0.16)' : checked ? '#008aff' : '#616161'};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  font-size: 14px;

  input {
    display: none;
  }

  span {
    font-size: 12px;
    color: ${({ checked, disabled }) =>
      disabled
        ? 'rgba(55, 56, 60, 0.16)'
        : checked
          ? '#008aff'
          : 'rgba(55, 56, 60, 0.61)'};
  }
`;

const DetailBtn = styled.div<{ $active: boolean; $disabled?: boolean }>`
  display: flex;
  padding: 10px 12px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 8px;
  width: 100%;
  height: 40px;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;

  background: #f7f8fc;
  color: rgba(55, 56, 60, 0.61);
  border: 1px solid #f7f8fc;
  ${({ $active }) =>
    $active &&
    `
    color: #222;
  `}

  ${({ $disabled }) =>
    $disabled &&
    `
    color: rgba(55, 56, 60, 0.16);
    pointer-events: none;
  `};

  &:focus {
    background: #fff;
    color: rgba(55, 56, 60, 0.61);
    border: 1px solid #008aff;
  }

  & > span {
    color: #616161;
    ${({ $disabled }) => $disabled && `color: rgba(55, 56, 60, 0.16)`};
  }
`;

const DetailBtnText = styled.div`
  flex: 1 0 0;
`;

const SelectHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  align-self: stretch;
`;

const SelectTitleWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex: 1 0 0;
`;

const SelectTitle = styled.div`
  color: #222;
  font-size: 18px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.36px;
`;

const SelectHeaderStep = styled.div`
  color: #008aff;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const SelectMain = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
  width: 100%;
`;

const Divider = styled.div`
  height: 1px;
  align-self: stretch;
  background: rgba(112, 115, 124, 0.16);
`;

const SelectedLabel = styled.span`
  color: rgba(55, 56, 60, 0.61);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;
`;

const ColumnBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const RadioButtonLabelDescription = styled.span`
  color: rgba(55, 56, 60, 0.61);
  text-align: center;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 17.4px */
  letter-spacing: -0.24px;
  white-space: pre-line;
`;
const BottomButtonBoxText = styled.div`
  display: flex;
  padding: 8px 0;
  justify-content: center;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  color: #008aff;
  text-align: center;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
`;

const InputDesc = styled.div`
  display: flex;
  padding: 0 12px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  color: #616161;
  font-size: 12px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.24px;
`;

export const s = {
  TitleBox,
  PatternBoxContainer,
  Wrapper,
  PlusButton,
  FilterRowContent,
  Container,
  TabBox,
  Tab,
  PatternBox,
  Row,
  Block,
  BlockLabel,
  BlockLabelDescription,
  BlockDescriptionSection,
  BlockContent,
  BlockContent02,
  DateInput,
  RadioButtonLabel,
  ShowOptionButton,
  BottomButtonBox,
  ResetButton,
  NextButton,
  AnalyzeButton,
  SelectedArea,
  SelectedBox,
  SelectedItem,
  TooltipBox,
  TooltipTitle,
  InvestmentAmountBox,
  InvestmentAmountInput,
  Divider,
  GuideBox,
  GuideList,
  GuideListItem,
  Number,
  GuideText,
  BlueText,
  RedText,
  Column,
  AnalysisTabBox,
  AnalysisTab,
  TempBox,
  InputBox,
  NumberInput,
  InputDescription,
  CheckButtonLabel,
  RadioButtonLabel02,
  DetailBtn,
  DetailBtnText,
  SelectHeader,
  SelectTitleWrapper,
  SelectMain,
  SelectHeaderStep,
  SelectTitle,
  SelectedLabel,
  ColumnBox,
  RadioButtonLabelDescription,
  BottomButtonBoxText,
  ArrowButton,
  InputDesc,
};
